import { render, staticRenderFns } from "./Detail-Quotation.vue?vue&type=template&id=1b679222&scoped=true"
import script from "./Detail-Quotation.vue?vue&type=script&lang=js"
export * from "./Detail-Quotation.vue?vue&type=script&lang=js"
import style0 from "./Detail-Quotation.vue?vue&type=style&index=0&id=1b679222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b679222",
  null
  
)

export default component.exports